<template>
    <div>
        <div class="columns">
            <div class="column">
                <div class="wrapper">
                    <p class="is-flex is-flex-direction-row is-justify-content-center"><span v-if="profile.completedstage1 === true" @click="profile.completedstage1=false" class="btn btn-clear">previous page</span></p>
                    <sign-up2 :prevroute="prevRoute" v-if="!profile.completedstage1" :profile="profile" @update="saveData"/>
                    <sign-up3 :prevroute="prevRoute" v-else :profile="profile" @update="saveData"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>

import SignUp2 from "@/components/SignUp2";
import SignUp3 from "@/components/SignUp3";
import axios from "axios"

export default {
    name: 'SignUpContainer',
    components: {
        SignUp2, SignUp3
    },
    props: {},
    data() {
        return {
            ind:2,
            prevRoute: null,
            profile: {
                completedStage1: true,
                completedStage2: true
            },
        }
    },
    methods: {
        async saveData(obj) {
            Object.assign(this.profile, obj)
            axios.post("/api/profile", this.profile).then(response => {
                this.profile = response.data
                this.$store.commit("auth/SET_USER_PROFILE", this.profile)
                if(this.profile.completedStage1){
                    this.$store.commit("auth/SET_PROFILE",1)
                }
                if(this.profile.completedStage2){
                    this.$store.commit("auth/SET_PROFILE",2)
                }
                if(this.profile.email) {
                    this.$store.commit("auth/SET_EMAIL", this.profile.email)
                }
            }).catch(() => {
            })
        },

    },
    async mounted() {
        await axios.get("/api/profile").then(response => {
                this.profile = response.data
                this.$store.commit("auth/SET_USER_PROFILE", this.profile);
                if(this.profile.completedStage1){
                    this.$store.commit("auth/SET_PROFILE",1)
                }
                if(this.profile.completedStage2){
                    this.$store.commit("auth/SET_PROFILE",2)
                }
                if(this.profile.email) {
                    this.$store.commit("auth/SET_EMAIL", this.profile.email)
                }
            }
        ).catch(() => {
        })
    },
    beforeRouteEnter(to, from, next){
        if(from.path == "/login-check"){
            this.prevRoute = from.path
        }
        else if(from.path){
            this.prevRoute = from.path
        }
        else{
            this.prevRoute = "/"
        }
        next()
    },
    metaInfo() {
      return {
          title: !this.profile.completedstage1 ? "Register Step 2 | Pickafund" : "Register Step 3 | Pickafund",
          meta: [
              { name: 'description', content:  'Sign up for free to enjoy full access on Pickafund'},
              { property: 'og:title', content: !this.profile.completedstage1 ? "Register Step 2 | Pickafund" : "Register Step 3 | Pickafund"},
          ]
      }
    },
}
</script>


